import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    TextField,
    Box
} from '@mui/material';

const ImpersonationReasonDialog = ({ 
    open, 
    onClose, 
    onConfirm, 
    patient,
    isLoading = false 
}) => {
    const [reason, setReason] = useState('');

    const handleConfirm = () => {
        onConfirm(reason);
        setReason(''); // Reset reason after confirmation
    };

    const handleClose = () => {
        setReason(''); // Reset reason on close
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="impersonation-reason-dialog-title"
            aria-describedby="impersonation-reason-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                role: 'dialog',
                'aria-modal': true
            }}
        >
            <DialogTitle id="impersonation-reason-dialog-title">
                Impersonate Patient
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="impersonation-reason-dialog-description">
                    You are about to impersonate {patient?.first_name} {patient?.last_name} ({patient?.email}). 
                    Please provide a reason for this impersonation session for audit purposes.
                </DialogContentText>
                <Box sx={{ mt: 2 }}>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Reason for Impersonation *"
                        fullWidth
                        multiline
                        rows={3}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="e.g., Assisting patient with account setup, debugging user-reported issue..."
                        sx={{ mt: 1 }}
                        inputProps={{
                            'aria-describedby': 'reason-field-help-text'
                        }}
                        helperText="This reason will be logged for audit purposes (required)"
                        id="reason-field-help-text"
                        required
                        error={reason.trim() === ''}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit" disabled={isLoading}>
                    Cancel
                </Button>
                <Button 
                    onClick={handleConfirm} 
                    color="primary" 
                    variant="contained"
                    disabled={isLoading || reason.trim() === ''}
                >
                    {isLoading ? 'Creating Session...' : 'Confirm Impersonation'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImpersonationReasonDialog; 